var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#FE3839"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_993_42437",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 14,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 14,
    height: 14,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_993_42437)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 14,
    height: 14,
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_993_42437",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_993_42437",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL+SURBVHgB7ZtNTxNBGMf/z2yhAa9wLZFwwBDjoQS65UL8CKKGmy+cjJGLeJAPoDFw1ZOSeFKjCUc9GS6kLUkP6oUDicgJAl55W9jHWRJht22a7k6n1c78kqYzT2anff47z7zszAIWi8VkCJph1+3xmWYJPCWzI/LTW/cCoiMwfyfGa/Skl2hl5QQa0SoA5/MD7PMXmRxGMn5K4a5TsbgJTWgTgLPZLu5Or8u7OQg11sk7zlK5vA8NCOgilbrXBOcDhtGVfgRNpKAJJjETzsum/AG+/5DW1n7XvW5iIuOf+ItEuHVR11n/8QIa0BYCvps/lC0gff5Djhig1dWtRq6V4dPHXd27IdO+KBYuQQP6QiDkfECjzp+VLZf3Kky90IQ+Af4TqkKAcxO3Gf5LmexDZ7FFPuZorfAxbKxqAdL5BXSe8wEZFnhVaawVAtrird2w7EwrbVUCyGnrA/n1Cx0H7wmmx5XW2MOgn3M5nJfDk/b1RD1U/4/xo4AVAIZjBYDhWAFgOMYLoO2ByF9Ci6v9WosR1fKqaG8BocVVzcWIanlVWhECmVC6kVVm3PJK2E4QhmMFgOFYAWA4VgAYjhUAhmMFgOFYAWA4VgAYjhUA+jk/7iJ3MRs5JhO3vBLaBbjYbq+9Pa1aXhW7PQ7DsQIgPl44w9ls284U8dBQusIU+2R5EgF2ojWIEbSL/v5rkTzHHzViC0CgUrSG1A20DZqJZvkHYpKgBdByOMeEWXbdpO8DJIbHxi77zPfDNmLxCTGJL4B3GAiwHbL0MuPzwejoIFrEUS53hYXzlaKbu5vo6X6PmCQaw3k8P83E76JGPiEhlmTiDXZ3v9HGxhGaSNDZerK/cciZIkHB+wORztcH300Vi28Rk8STmFPXXSDGHP4BZBg+dwqFeSRAaRbH4+PPmMRTtBHp/KJ0/gkSojQRolJpnsi5gyD+Ws82gadVnA9oyjyeJydTpwfH0w7hprwjV5k5Q00+fSIn/J50eEfWWzoFlh3PW9b1IpXFYjGHP2l2As5366ocAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.dbbd8a388713c05b87b4499ee4583680.svg";
export { ForwardRef as ReactComponent };